import { render, staticRenderFns } from "./AbstainModal.vue?vue&type=template&id=48d1c562&scoped=true"
import script from "./AbstainModal.vue?vue&type=script&lang=js"
export * from "./AbstainModal.vue?vue&type=script&lang=js"
import style0 from "./AbstainModal.vue?vue&type=style&index=0&id=48d1c562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1c562",
  null
  
)

export default component.exports